import injectionCode from '../../../../preview/advanced-checkout'

const type = 'advanced'
const path = '/advance/3ds-node/public/'
const name = 'checkout.ejs'

const conditions = [
  {
    parameter: 'buttons',
    type: 'includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, conditions, injectionCode }
